import axios from '@/plugins/axios';
import { OPERATION_TYPE } from './constants';

class RoleManageLogApi {
  static getLogs(
    page = 1,
    limit = 10,
    type = OPERATION_TYPE.ALL,
    optNickName = '',
  ) {
    return axios({
      url: '/api/sys/log/role/page',
      data: {
        page,
        limit,
        type,
        opt_nick_name: optNickName,
      },
      method: 'post',
      headers: {
        meta: {
          skipSuccess: true,
          desc: '查询角色管理日志',
        },
      },
    });
  }

  static export(data) {
    return axios({
      url: '/api/sys/log/role/export',
      method: 'post',
      data,
      headers: {
        meta: {
          skipSuccess: true,
          desc: '导出',
        },
      },
    });
  }
}

export default RoleManageLogApi;
